import { render } from "./InvoicesCreateNew.vue?vue&type=template&id=27b0dca2"
import script from "./InvoicesCreateNew.vue?vue&type=script&lang=js"
export * from "./InvoicesCreateNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__